import Vue from 'vue'
// import math from './math'

// import VueScrollTo from 'vue-scrollto'
// Vue.use(VueScrollTo, {
//   duration: 300,
//   offset: 0
// })


import authCode from './auth_code' //权限码获取
import { getStore } from './storage'

export function hasAuth(authName) {
  let value = authCode[authName]

  if (!authName || !value) {
    return true
  } else {
    let userInfo = getStore('orientUser')
    if (!userInfo) {
      return false
    }

    let code = value.pAuthCode
    let userAuthCodes = []
    let codes = userInfo.auth_codes

    if (codes && codes.length > 0) {
      userAuthCodes = codes[0].Codes
    }

    if (code == "") {
      return false
    }

    if (userInfo.is_super_admin) {
      return true
    }
    return userAuthCodes.includes(code)
  }
}
// 深度拷贝
export function clone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'clone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = clone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function copyCustomParam(source, target) {
  let newSource = clone(source)
  newSource.map((p) => {
    let params = target.filter((i) => i.label == p.label)
    if (params.length > 0) {
      p.value = params[0].value
    }
  })
  return newSource
}

export function getCustomParamValue(source, label) {
  if (!source) return ''
  let params = source.filter((i) => i.label == label)
  return params.length > 0 ? params[0].value : ''

}

export function getRecordExtrainfo(well) {
  let used_extra = [
    { key: 'block', value: well.well_block, label: '使用区块' },
    { key: 'well_team_number', value: well.well_team, label: '井队号' },
    { key: 'well_number', value: well.well_number, label: '井号' },
  ]
  return used_extra
}

export function filterEncode(filter) {
  return { filter: JSON.stringify(filter) }
}

export function filterDecode(filter) {
  return JSON.parse(filter)
}

export default {
  install(Vue, options) {
    Vue.prototype.clone = clone
    Vue.prototype.hasAuth = hasAuth
    Vue.prototype.copyCustomParam = copyCustomParam
    Vue.prototype.getCustomParamValue = getCustomParamValue
    Vue.prototype.groupBy = groupBy
    Vue.prototype.filterEncode = filterEncode
    Vue.prototype.filterDecode = filterDecode
    Vue.prototype.getRecordExtrainfo = getRecordExtrainfo
  }
}

export function formatTime(datetime, format) {
  if (!datetime) {
    return '-'
  }
  const time = new Date(datetime)
  if (!time || time.getTime() <= 0) {
    return '-'
  }

  format = format || 'YYYY-MM-DD'
  return Vue.time(time).format(format)
}

export function timePast(datetime) {
  const time = new Date(datetime).getTime()
  if (time <= 0) {
    return '-'
  }

  let now = new Date().getTime();   //获取当前时间毫秒
  let diff = (now - time) / 1000;//时间差

  if (diff < 60) {
    return '刚刚'
  } else if (diff >= 60 && diff < 3600) {
    return parseInt(diff / 60) + '分钟前'
  } else if (diff >= 3600 && diff < 3600 * 24) {
    return parseInt(diff / 3600) + '小时前'
  } else if (diff >= 3600 * 24 && diff < 3600 * 24 * 30) {
    return parseInt(diff / (3600 * 24)) + '天前'
  } else if (diff >= 3600 * 24 * 30 && diff < 3600 * 24 * 365) {
    return parseInt(diff / (3600 * 24 * 30)) + '个月前'
  } else {
    return formatTime(datetime)
  }
}

export function messagesFormat(messages) {
  if (!messages || messages.length == 0) {
    return []
  }
  return messages.map((item) => {
    switch (item.type) {
      case 1: case 2: case 3: case 4:
        item.link = '/products/' + item.event_id
        break
      case 5: case 6: case 7: case 8:
        item.link = '/instruments/' + item.event_id
        break
      case 20: case 21: case 22: case 23:
        item.link = '/instrument_items/' + item.event_id
        break
      case 30:
        item.link = '/approve_applies/' + item.event_id
        break
      case 31: case 32:
        item.link = '/my_applies/' + item.event_id
        break
      case 35:
      case 38:
        item.link = '/my_supplies/' + item.event_id
        break
      case 36: case 37:
        item.link = '/supplies/' + item.event_id
        break
      default:
        item.link = ''
        break
    }
    return item
  })
}


export function isImage(url) {
  var index = url.lastIndexOf(".");
  var ext = url.substr(index + 1);
  return [
    'png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].
    indexOf(ext.toLowerCase()) !== -1;
}

export function canPreviewFile(url) {
  var index = url.lastIndexOf(".");
  var ext = url.substr(index + 1);
  return [
    'png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'svg', 'tiff', 'pdf', '.doc', 'docx', 'xls', 'xlsx', 'ppt', 'html', 'txt'].
    indexOf(ext.toLowerCase()) !== -1;
}

export function showEmptyString(str) {
  if (!str || str.length == 0) {
    return '-'
  }
  return str
}

export function scrollToTop() {
  const el = document.querySelector("body");
  const beginTime = Date.now();
  const beginValue = el.scrollTop;
  const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16));
  const cubic = value => Math.pow(value, 3);
  const easeInOutCubic = value => value < 0.5
    ? cubic(value * 2) / 2
    : 1 - cubic((1 - value) * 2) / 2;

  const frameFunc = () => {
    const progress = (Date.now() - beginTime) / 500;
    if (progress < 1) {
      el.scrollTop = beginValue * (1 - easeInOutCubic(progress));
      rAF(frameFunc);
    } else {
      el.scrollTop = 0;
    }
  };
  rAF(frameFunc);
}

// 数组分类
export function groupBy(array, f) {
  let groups = {};
  array.forEach(function (o) {
    let group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  });
}

export function calculateHoursDifference(time1, time2) {
  if (!time1 || !time2) {
    return 0
  }

  // 将时间字符串拆分为年、月、日、时、分和秒
  const [year1, month1, day1, hour1] = time1.split(/[- :]/);
  const [year2, month2, day2, hour2] = time2.split(/[- :]/);

  // 将时间字符串转换为 Date 对象
  const date1 = new Date(year1, month1 - 1, day1, hour1);
  const date2 = new Date(year2, month2 - 1, day2, hour2);

  if (date2 < date1) {
    return 0
  }
  // 计算两个日期之间的差值，单位为毫秒
  const diffInMilliseconds = Math.abs(date2 - date1);

  // 将差值转换为小时
  const diffInHours = Math.round(diffInMilliseconds / (1000 * 60 * 60));

  return diffInHours;
}